import React, { forwardRef, ReactNode } from 'react'

import { Checkbox } from 'primsell-shared-layer/components'

import * as S from './list-item.styles'

import { CheckboxColorT, CheckboxVariantT } from '../index.types'

export enum ListItemVariantE {
  DEFAULT = 'DEFAULT',
  SMALL = 'SMALL',
}

interface IListItemProps {
  children: ReactNode
  styleVariant?: ListItemVariantE
  isSelected: boolean
  checkboxVariant?: CheckboxVariantT
  checkboxColor?: CheckboxColorT
  onClick?: React.MouseEventHandler<HTMLDivElement>
}

const ListItem = forwardRef<HTMLDivElement, IListItemProps>(
  ({ children, styleVariant = ListItemVariantE.DEFAULT, isSelected, checkboxVariant, checkboxColor, onClick }, ref) => {
    return (
      <S.Option ref={ref} $isSelected={isSelected} styleVariant={styleVariant} onClick={onClick}>
        {checkboxVariant && <Checkbox checked={isSelected} variant={checkboxVariant} color={checkboxColor} readOnly />}
        <S.Label $isSelected={isSelected}>{children}</S.Label>
      </S.Option>
    )
  }
)

ListItem.displayName = 'ListItem'

export { ListItem }
